// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"app-components-pay-newcardform--button","error":"app-components-pay-newcardform--error"};